import { MARKETPLACE, pathUnder } from '@/lib/marketplacePaths';

export type StorefrontNavItem = {
  id: string;
  label: string;
  to: string;
  /** Island context shown in mobile drawer subtitle. */
  context?: string;
};

export type StorefrontNavFlags = {
  propertyListings?: boolean;
  classifieds?: boolean;
  businessDirectory?: boolean;
};

/** Flat desktop/mobile strip — Shop · Properties · Classifieds · Businesses · Find a pro · Deals. */
export function storefrontNavStripLinks(flags: StorefrontNavFlags = {}): StorefrontNavItem[] {
  const links: StorefrontNavItem[] = [
    { id: 'shop', label: 'Shop', to: MARKETPLACE.shop, context: 'Products from Grenada vendors' },
  ];
  if (flags.propertyListings !== false) {
    links.push({ id: 'property', label: 'Properties', to: MARKETPLACE.realEstate });
  }
  if (flags.classifieds !== false) {
    links.push({ id: 'classifieds', label: 'Classifieds', to: MARKETPLACE.classifieds });
  }
  if (flags.businessDirectory !== false) {
    links.push({ id: 'vendors', label: 'Businesses', to: MARKETPLACE.vendors });
  }
  links.push(
    { id: 'find-a-pro', label: 'Find a pro', to: MARKETPLACE.findAPro, context: 'Book services in Grenada' },
    { id: 'deals', label: 'Deals', to: MARKETPLACE.deals, context: 'Promotions across ShopGND' },
  );
  return links;
}

/** @deprecated Use storefrontNavStripLinks — kept for mobile browse sheet removal migration. */
export const STOREFRONT_PRIMARY_NAV: StorefrontNavItem[] = storefrontNavStripLinks();

/** @deprecated Browse links are inlined in the nav strip. */
export const STOREFRONT_BROWSE_LINKS: StorefrontNavItem[] = [
  { id: 'property', label: 'Properties', to: MARKETPLACE.realEstate },
  { id: 'classifieds', label: 'Classifieds', to: MARKETPLACE.classifieds },
  { id: 'vendors', label: 'Businesses', to: MARKETPLACE.vendors },
];

export function storefrontNavIsActive(pathname: string, item: StorefrontNavItem): boolean {
  if (item.id === 'shop') return pathUnder(pathname, MARKETPLACE.shop);
  if (item.id === 'property') return pathUnder(pathname, MARKETPLACE.realEstate);
  if (item.id === 'classifieds') return pathUnder(pathname, MARKETPLACE.classifieds);
  if (item.id === 'vendors') return pathUnder(pathname, MARKETPLACE.vendors);
  if (item.id === 'find-a-pro') return pathUnder(pathname, MARKETPLACE.findAPro);
  if (item.id === 'deals') return pathUnder(pathname, MARKETPLACE.deals);
  return pathUnder(pathname, item.to);
}
